export interface FooterProps {
  isSubmitting: boolean
  onDelete?: () => any
  disabled: boolean
  onSubmit: () => void
}
